import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation('home');
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: t('hero.slides.0.title'),
      description: t('hero.slides.0.description'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20technology%20innovation%20with%20digital%20transformation%2C%20futuristic%20blue%20and%20white%20tech%20background%20with%20abstract%20geometric%20patterns%2C%20clean%20minimalist%20design%2C%20professional%20corporate%20atmosphere%2C%20soft%20lighting&width=1920&height=800&seq=hero1&orientation=landscape'
    },
    {
      title: t('hero.slides.1.title'),
      description: t('hero.slides.1.description'),
      image: 'https://readdy.ai/api/search-image?query=Smart%20manufacturing%20management%20system%20with%20industrial%20automation%2C%20modern%20factory%20with%20digital%20interfaces%2C%20clean%20white%20and%20blue%20technology%20theme%2C%20professional%20business%20environment%2C%20bright%20ambient%20lighting&width=1920&height=800&seq=hero2&orientation=landscape'
    },
    {
      title: t('hero.slides.2.title'),
      description: t('hero.slides.2.description'),
      image: 'https://readdy.ai/api/search-image?query=Enterprise%20operational%20excellence%20management%20with%20team%20collaboration%2C%20modern%20office%20with%20digital%20workflow%20systems%2C%20clean%20white%20background%20with%20orange%20accents%2C%20professional%20corporate%20setting%2C%20natural%20lighting&width=1920&height=800&seq=hero3&orientation=landscape'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
          
          {/* Content */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center text-white px-4 max-w-4xl w-full">
              <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-fade-in">
                {slide.title}
              </h1>
              <p className="text-xl md:text-2xl mb-8 animate-fade-in-delay">
                {slide.description}
              </p>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-8 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-all duration-300 text-white backdrop-blur-sm cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-8 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-all duration-300 text-white backdrop-blur-sm cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      {/* Dots Navigation */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
}
